import { createContext } from "react";
import type { SetSelectedEntitiesContextType } from "../SelectedEntitiesProvider.types";

const SetSelectedEntitiesContext = createContext<SetSelectedEntitiesContextType | undefined>(undefined);
SetSelectedEntitiesContext.displayName = "SetSelectedEntitiesContext";

export default SetSelectedEntitiesContext;
